import React from "react";
import Overview from "./Overview";
import Add from "./Add";
import Edit from "./Edit";
import Detail from "./Details";

import { PositionProvider } from "../../../context/PositionContext";

export const BestOfAfrica = () => {
  return (
    
      <PositionProvider>
        <Overview />
      </PositionProvider>
    
  );
};

export const AddBestOfAfrica = () => {
  return (
    
      
        <Add />
      
    
  );
};

export const EditBestOfAfrica = () => {
  return (
    
      
        <Edit />
      
    
  );
};

export const ViewBestOfAfrica = () => {
  return (
    
      <Detail />
    
  );
};
